var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 15 15",
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a1 1 0 011-1h6a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V1zm1 13.5a.5.5 0 101 0 .5.5 0 00-1 0zm2 0a.5.5 0 101 0 .5.5 0 00-1 0zM9.5 1a.5.5 0 000 1h5a.5.5 0 000-1h-5zM9 3.5a.5.5 0 00.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5zM1.5 2A1.5 1.5 0 000 3.5v7A1.5 1.5 0 001.5 12H6v2h-.5a.5.5 0 000 1H7v-4H1.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5H7V2H1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcIcon);
export default __webpack_public_path__ + "static/media/pc-icon.461859542eb5782b2ee762efa841b88b.svg";
export { ForwardRef as ReactComponent };